import React, { useContext } from 'react';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext.js';
import { Button } from '../../button/index.js';
import styles from './exercise-states.module.css.js';

const ExerciseFailed = ({ onClose, onRetry }) => {
    const { exerciseFailedState: translations } = useContext(ExerciseTranslationsContext);
    return (React.createElement("div", { className: styles.overlay },
        React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.icon },
                React.createElement("i", { className: 'bc-icon bc-icon-notification-warning', role: 'img' })),
            React.createElement("div", { className: styles.message },
                React.createElement("p", null, translations.message),
                React.createElement("div", { className: styles.buttons },
                    React.createElement(Button, { variant: 'primary', onClick: onRetry }, translations.buttons.retry),
                    React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.buttons.close))))));
};

export { ExerciseFailed };
